export default "__VITE_ASSET__B0o1qcsg__"